// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------


// ============ Header cart Total Price Start ============

// Select the element that displays the cart total
function formatINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(amount / 100);
}
let lastCartTotal = null;
document.addEventListener("DOMContentLoaded", () => {
  const originalFetch = window.fetch;
 
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
 
    if (
      args[0].includes("/cart") ||
      args[0].includes("/cart/add.js") ||
      args[0].includes("/cart/change.js") ||
      args[0].includes("/cart/update.js")
    ) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (cart.total_price !== lastCartTotal) {
            lastCartTotal = cart.total_price;
            if(lastCartTotal=='0'){
            document.querySelector(".header-cart-total").innerText = `RS. 0.00`; 
            }
            else{
            document.querySelector(".header-cart-total").innerText = `RS. ${formatINR(lastCartTotal)}`;
            }
          }
        });
    }
 
    return response;
  };
});

// ============ Header cart Total Price R ============


// --header cart totel new code----28-11-25-----

// function formatINR(amount) {
//   return new Intl.NumberFormat("en-IN", {
//     maximumFractionDigits: 0,
//   }).format(amount / 100);
// } 
// setInterval(() => {
//     const bubblecount = document.querySelector("#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']")
//     const cartTotal = document.querySelector(".header-cart-total");
//     if(bubblecount){
//       fetch("/cart.js")
//         .then((res) => res.json())
//         .then((cart) => {
//           let cartCount = cart.item_count;
//           let cPrice = cart.total_price;
//           if(cartCount != bubblecount.textContent || cartTotal.getAttribute("data-price")!=cPrice){
//             cartTotal.textContent =`RS. ${cPrice==0 ? "0.00" : formatINR(cart.total_price)}` ;
//             bubblecount.textContent = cartCount;
//             updateCartDrawerUI()
//           }
//       });
//     }
//   }, 1000);
//   async function updateCartDrawerUI() {
//         try {
//           const data = await (await fetch("/?sections=cart-drawer,cart-icon-bubble")).json()
//           , newCartDrawerHTML = data["cart-drawer"]
//           , newCartDrawer = new DOMParser().parseFromString(newCartDrawerHTML, "text/html").querySelector("cart-drawer")
//           , currentCartDrawer = document.querySelector("cart-drawer");
//           newCartDrawer && currentCartDrawer && (currentCartDrawer.classList.remove("is-empty"),
//           currentCartDrawer.innerHTML = newCartDrawer.innerHTML,
//           document.querySelector("#CartDrawer-Overlay")?.addEventListener("click", () => {
//             document.querySelector("cart-drawer.drawer")?.classList.remove("active")
//           }
//         ));
//         } catch (err) {
//             console.error("Failed to update cart drawer and bubble:", err)
//         }
//     }

// --header cart totel new code----28-11-25-----





// --------- Draggable Scroll JS ---------
function enableLeftClickDragScroll(container) {
  if (!container) return;

  let isDragging = false;
  let dragStarted = false;
  let startX = 0;
  let scrollStart = 0;
  const dragThreshold = 5;
  const scrollSpeedFactor = 0.9; // Lower values = slower scrolling

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDragging = true;
    dragStarted = false;
    startX = e.pageX;
    scrollStart = container.scrollLeft;
    container.classList.add("is-dragging");
    e.preventDefault();
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;

    if (!dragStarted && Math.abs(deltaX) > dragThreshold) {
      dragStarted = true;
    }

    if (dragStarted) {
      container.scrollLeft = scrollStart - deltaX * scrollSpeedFactor;
    }
  });

  container.addEventListener("mouseup", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseleave", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("click", (e) => {
    if (dragStarted) {
      e.preventDefault();
      e.stopPropagation();
      dragStarted = false;
    }
  });

  container.classList.add("is-draggable");
}


function waitForElementAndInit(selector) {
  // Initialize any that already exist
  document.querySelectorAll(selector).forEach(el => {
    if (!el._dragInitialized) {
      enableLeftClickDragScroll(el);
      el._dragInitialized = true;
    }
  });

  // Observe future additions
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(selector) && !node._dragInitialized) {
          enableLeftClickDragScroll(node);
          node._dragInitialized = true;
        }

        // Check descendants too
        node.querySelectorAll?.(selector)?.forEach((el) => {
          if (!el._dragInitialized) {
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
          }
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // ===============================================
  // ADD CLASS OR ID OF CONTAINER TO SCROLL [ DEV-03 ]
  // ===============================================
  const scrollSelectors = [".product-grid",".predictive-search__results-list"];

  scrollSelectors.forEach(selector => {
    waitForElementAndInit(selector);
  });
});

// --------- Draggable JS ---------


// --- Header BG start [DEV-03] --------------

document.addEventListener("DOMContentLoaded", () => {
  const mainHeader = document.querySelector(".main-header");

  document.addEventListener("scroll", () => {
    if (window.scrollY > mainHeader.offsetHeight) {
      mainHeader.classList.add("active");
    } else {
      mainHeader.classList.remove("active");
    }
  });
});

// --- Header BG end --------------


// ------------ mobile menu x design -----

// const toggleBtn = document.querySelector('.toggle-btn-d');
// const mobMenuBox = document.querySelector('.mob-menu-box');

// toggleBtn.addEventListener('click', () => {
//   toggleBtn.classList.toggle('active');
//   mobMenuBox.classList.toggle('active');
// });

// ------------ mobile menu x design -----


// -------- marquee close btn mobile -------
function closemq() {
  const marqueecl = document.querySelector(".mob-marquee-span");
  marqueecl.classList.toggle("close");
}

// -------- marquee close btn mobile -------


// ---------- search box ----

  // function clickmesearch() {
  //   const boxes = document.querySelectorAll('.my-search-box');
  //   boxes.forEach(box => {
  //     box.classList.toggle('active');
  //   });
  // }


// ---------- search box ----

// Search toggle function
function clickmesearch() {
    const boxes = document.querySelectorAll('.my-search-box');
    const toggleBtn = document.querySelector('.toggle-btn-d');
    const mobMenuBox = document.querySelector('.mob-menu-box');
    
    boxes.forEach(box => {
        box.classList.toggle('active');
    });
    
    // Close mobile menu when search is opened
    const isSearchActive = document.querySelector('.my-search-box.active');
    if (isSearchActive) {
        toggleBtn.classList.remove('active');
        mobMenuBox.classList.remove('active');
    }
}

// Mobile menu toggle
const toggleBtn = document.querySelector('.toggle-btn-d');
const mobMenuBox = document.querySelector('.mob-menu-box');

toggleBtn.addEventListener('click', () => {
    toggleBtn.classList.toggle('active');
    mobMenuBox.classList.toggle('active');
    
    // Close search when mobile menu is opened
    const isMenuActive = mobMenuBox.classList.contains('active');
    if (isMenuActive) {
        const boxes = document.querySelectorAll('.my-search-box');
        boxes.forEach(box => {
            box.classList.remove('active');
        });
    }
});


// ---- for search --------
document.querySelector("details").setAttribute("open", "true");
// ---- for search --------

// ============ PDP Description Read more ============ 

document.addEventListener('DOMContentLoaded', () => {
  try{
  const paragraphs = document.querySelectorAll('.expandable-text');
paragraphs.forEach(paragraph => {
    const words = paragraph.innerText.split(' ');

    if (words.length > 30) {
      const visibleText = words.slice(0, 50).join(' ');
      const hiddenText = words.slice(50).join(' ');

      paragraph.innerHTML = `
        ${visibleText}<span class="dots">...</span>
        <span class="more" style="display:none;"> ${hiddenText}</span>
        <button class="read-more-btn" type="button" style="opacity: 1 !important;">Read More</button>
      `;

      const btn = paragraph.querySelector('.read-more-btn');
      const dots = paragraph.querySelector('.dots');
      const more = paragraph.querySelector('.more');

      btn.addEventListener('click', () => {
        if (paragraph.classList.contains('expanded')) {
          paragraph.classList.remove('expanded');
          more.style.display = 'none';
          dots.style.display = 'inline';
          btn.innerText = 'Read More';
        } else {
          paragraph.classList.add('expanded');
          more.style.display = 'inline';
          dots.style.display = 'none';
          btn.innerText = 'Read Less';
        }
      });
    }
  });
}catch(err){

}finally{
  document.querySelector(".product__info-wrapper").setAttribute("style","display:flex")
  setTimeout(()=>{
    document.querySelector(".product__media-wrapper slider-component").setAttribute("style","opacity:1 !important")
  },300)
}
});

//  ============ PDP Description Read more ============ 




document.addEventListener("DOMContentLoaded", () => {
  
  // Run only on desktop
  const isDesktop = window.innerWidth >= 1024;
  if (!isDesktop) return;

  const sliders = [
    document.querySelector(".option1-data .carousel"),
    document.querySelector(".collection .slider-mobile-gutter .grid")
  ];

  sliders.forEach((scrollContainer, index) => {
    if (!scrollContainer) return;

    // Prevent multiple initialization
    const initKey = `infiniteScrollInit_${index}`;
    if (window[initKey]) return;
    window[initKey] = true;

    // Duplicate items ONLY on desktop
    const items = Array.from(scrollContainer.children);
    items.forEach(el => {
      const clone = el.cloneNode(true);
      clone.classList.add("clone");
      scrollContainer.appendChild(clone);
    });

    let speed = 2;
    let interval = null;
    let isHovered = false;

    function startScroll() {
      if (interval) return;

      interval = setInterval(() => {
        if (isHovered) return;

        scrollContainer.scrollLeft += speed;

        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft -= scrollContainer.scrollWidth / 2;
        }
      }, 16);
    }

    function stopScroll() {
      clearInterval(interval);
      interval = null;
    }

    // Pause on hover (desktop only)
    scrollContainer.addEventListener("mouseenter", () => {
      isHovered = true;
      stopScroll();
    });

    scrollContainer.addEventListener("mouseleave", () => {
      isHovered = false;
      startScroll();
    });

    startScroll();
  });

});



